




import Vue from "vue";
import { PropValidator } from "vue/types/options";

export default Vue.extend({
  props: {
    representedValue: {
      required: true,
      default: null
    } as PropValidator<any>
  },
  computed: {
    classesAndText(): [string[], string] {
      const value = this.representedValue;
      if (value === undefined) {
        return [[], ""];
      }
      let classSuffix = "";
      let text = "";
      if (value == null) {
        classSuffix = "unspecified";
        text = "not specified";
      } else {
        if (typeof value === "number") {
          classSuffix = "number";
          text = String(value);
        }
        if (typeof value === "object") {
          classSuffix = "object";
          text = JSON.stringify(value);
        }
        if (typeof value === "string") {
          classSuffix = "string";
          text = `\u275D${value}\u275E`;
        }
        if (typeof value === "boolean") {
          classSuffix = "boolean";
          text = String(value);
        }
        if (Array.isArray(value)) {
          classSuffix = "array";
          text = value.toString();
        }
        if (typeof value === "function") {
          classSuffix = "function";
          text = "function(…) {…}";
        }
      }
      return [["value-token", `value-token__${classSuffix}`], text];
    },
    text(): string {
      return this.classesAndText[1];
    },
    classes(): string[] {
      return this.classesAndText[0];
    }
  }
});
